/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Erika entame son dernier voyage. Elle est hissée dans une bétaillère et part pour l’abattoir. En
compagnie d’autres vaches, elle sera poussée dans un enclos avant de passer par un sas grillagé
et d’arriver dans la salle d’abattage. Elle sera étourdie d’un coup de pistolet anesthésiant
puis pendue par une jambe au moyen d’une chaîne. Elle n’est pas encore morte. Le boucher coupe
alors l’un des vaisseaux principaux au niveau du cou ou du coeur pour la saigner. Le manque
d’oxygène dans le cerveau d’Erika la mène à la mort. Erika ne livre que de la viande dite de
transformation, utilisée pour fabriquer des saucisses, de la viande séchée, de la viande hachée
et d’autres produits carnés.`}</p>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  